function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 3C6.11719 3 3 6.14453 3 10C3 13.8828 6.11719 17 10 17C13.8555 17 17 13.8828 17 10C17 6.14453 13.8555 3 10 3ZM10 15.6875C6.85547 15.6875 4.3125 13.1445 4.3125 10C4.3125 6.88281 6.85547 4.3125 10 4.3125C13.1172 4.3125 15.6875 6.88281 15.6875 10C15.6875 13.1445 13.1172 15.6875 10 15.6875ZM10 12.1875C9.50781 12.1875 9.125 12.5703 9.125 13.0625C9.125 13.5547 9.48047 13.9375 10 13.9375C10.4648 13.9375 10.875 13.5547 10.875 13.0625C10.875 12.5703 10.4648 12.1875 10 12.1875ZM10.9023 6.5H9.50781C8.44141 6.5 7.59375 7.34766 7.59375 8.41406C7.59375 8.76953 7.89453 9.07031 8.25 9.07031C8.60547 9.07031 8.90625 8.76953 8.90625 8.41406C8.90625 8.08594 9.15234 7.8125 9.48047 7.8125H10.875C11.2305 7.8125 11.5312 8.08594 11.5312 8.41406C11.5312 8.63281 11.4219 8.82422 11.2305 8.93359L9.67188 9.86328C9.45312 10 9.34375 10.2188 9.34375 10.4375V10.875C9.34375 11.2305 9.64453 11.5312 10 11.5312C10.3555 11.5312 10.6562 11.2305 10.6562 10.875V10.8203L11.8867 10.0547C12.4609 9.69922 12.8164 9.07031 12.8164 8.41406C12.8438 7.34766 11.9961 6.5 10.9023 6.5Z",
  fill: "currentColor"
});

const SvgHelp = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgHelp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/help.2159b9a4.svg";
export { ForwardRef as ReactComponent };